import { defaultOrgTeams } from '../constants/org';
import { db, rootRef } from './firebase';
import { makePasswordFields } from './password';

/**
 * Firestore 트랜잭션으로 최초 시딩을 원자적으로 1회만 실행합니다.
 * PBKDF2 해시는 트랜잭션 밖에서 미리 계산합니다.
 */
export async function seedInitialData() {
  const seedRef = rootRef().collection('settings').doc('seed');
  const existing = await seedRef.get();
  if (existing.exists) return;

  const pw = await makePasswordFields('admin1234!');

  await db.runTransaction(async (transaction) => {
    const seedSnap = await transaction.get(seedRef);
    if (seedSnap.exists) return;

    defaultOrgTeams.forEach((d) => {
      const fullName = `${d.org} ${d.team}`;
      transaction.set(
        rootRef().collection('departments').doc(fullName),
        { name: fullName, org: d.org, team: d.team },
        { merge: true }
      );
    });

    transaction.set(
      rootRef().collection('members').doc('admin-master'),
      {
        id: 'admin-master',
        name: '관리자',
        duty: '담당자',
        department: '인사본부 인사팀',
        isAdmin: true,
        salt: pw.salt,
        passwordHash: pw.passwordHash,
        perfGrade: 'GD',
        behaviorGrade: 'GD',
        finalPerf: 'GD',
        finalBehavior: 'GD',
        note: '시스템 초기 관리자 계정 (최초 로그인 후 반드시 비밀번호 변경)',
        createdAt: Date.now(),
      },
      { merge: true }
    );

    transaction.set(seedRef, { done: true, at: Date.now() });
  });
}
